import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "./TestingLandingPageTemplate.css";
import heroImage from "../src/img/asian2.png";
import handshakeImage from "../src/img/splashColab.png";
import dashboardImage from "../../../assets/img/macbook_mockup2.png";
import singpassImage from "../src/img/singpass_logo.png";
import sllogo from "../src/img/sl_long_new_logo_wo_beta.png";
import phone from "../src/img/test-phone.png";
import bank_image from "../src/img/11.png";
import bank_image1 from "../src/img/12.png";
import bank_image2 from "../src/img/13.png";
import bank_image3 from "../src/img/14.png";
import bank_image4 from "../src/img/15.png";
import bank_image5 from "../src/img/16.png";
import bank_image6 from "../src/img/17.png";
import bank_image7 from "../src/img/18.png";
import bank_image8 from "../src/img/19.png";
import singpassScreen from "../src/img/singpassscreen.png";
import { IconButton } from "@mui/material";
import { ChevronRight, ExpandMore } from "@mui/icons-material";
import { useHistory } from "react-router-dom";
import maskotImg from "../src/img/maskot.png";
import chocouplogo from "../src/img/chocouplogo.png";

const TestingLandingPageTemplate = () => {
  const partner = "ChocoUp";

  const history = useHistory();
  const [screenWidth, setScreenWidth] = useState(1920);
  const [isCollapsed, setIsCollapsed] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Call handleResize initially to set the initial screen width
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const faqs = [
    {
      id: 1,
      title: "How do I apply for a Business Loan?",
      answer: (
        <p>
          Get started by clicking on the sign up button above and it will take
          you through a step by step process to sign up for a smartlend account.
          Once you’re done with your sign up, you can head on into the dashboard
          and click on the apply loan button located on the menu bar on the
          left.
        </p>
      ),
    },
    {
      id: 2,
      title: "Can anyone apply for a Business Loan?",
      answer: (
        <p>
          Currently, only Singapore locally incorporated LLP (Limited Liability
          Partnership) or Pte. Ltd. (Private Limited) entities are eligible to
          apply for a business loan. However, if you have a different type of
          corporate entity, please reach out to us at support@smart-lend.com,
          and we'll explore how we might be able to assist you.
        </p>
      ),
    },
    {
      id: 3,
      title: "Why can’t I apply for a loan?",
      answer: (
        <p>
          If you're unable to apply for a loan, it usually means that you
          haven't synchronized your Corp Pass account with your Singpass yet.
          This synchronization process is necessary for accessing and applying
          for loans.
        </p>
      ),
    },
    {
      id: 4,
      title: "Can I speak to the lenders of the platform?",
      answer: (
        <p>
          Yes, you can speak to the lenders on our platform, but only if the
          lender has expressed interest in your loan request. In such cases, a
          chatbot request feature will be enabled on our platform. However,
          please note that we do not provide users with the private contact
          information of our lenders due to our privacy policies.
        </p>
      ),
    },
    {
      id: 5,
      title: "How can I talk to my private lender?",
      answer: (
        <p>
          If you would like to reach your lender on the loan offer that they
          have offered, you can click on the offer in the requested loan page,
          select the lender, and proceed to click on the negotiation button
          where you’ll be taken to the messaging page where you can start a
          conversation with your lender.
        </p>
      ),
    },
    {
      id: 6,
      title: "My loan has disappeared, where did it go?",
      answer: (
        <p>
          If you can't find your loan, don't worry! Once a loan is approved by
          both the borrower and lender, it is moved to the accepted loan page.
          Here, you can check the status of your loan, which will indicate the
          stage it's in before being disbursed. After your loan is disbursed, it
          will be moved to the "loan in progress" page. Here, you'll find
          detailed information about your loan and can make payments
          accordingly.
        </p>
      ),
    },
    {
      id: 7,
      title: "How long does it take for me to get a loan approved?",
      answer: (
        <div>
          <p>
            The approval time for your loan depends on several factors. First,
            you need to receive an offer from a lender. At Smart-Lend, we have a
            wide network of lenders who review your financial profile and the
            documents you've provided before making an offer. This process
            usually takes between 1 to 5 working days.
          </p>
          <p>
            Keep an eye out for our upcoming Service Guarantee feature! Soon,
            borrowers will enjoy even faster turnaround times, with approvals
            possible within 24 hours. Stay tuned for more details when we
            introduce this new feature.
          </p>
        </div>
      ),
    },
  ];
  const FAQItem = ({ id, title, answer, index }) => {
    return (
      <div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            borderBottom: "0.01rem solid #d5dee0",
            cursor: "pointer",
            justifyContent: "space-between",
            marginTop: "10px",
          }}
          onClick={() => {
            console.log(index);
            if (isCollapsed === index) {
              setIsCollapsed(null);
            } else {
              setIsCollapsed(index);
            }
          }}
          className="mui-button"
        >
          <div
            variant="subtitle1"
            style={{
              fontWeight: "600",
              fontSize: screenWidth > 1200 ? "17px" : "14px",
            }}
          >
            {title}
          </div>
          <IconButton
            onClick={() => {
              console.log(index);
              if (isCollapsed === index) {
                setIsCollapsed(null);
              } else {
                setIsCollapsed(index);
              }
            }}
          >
            <ChevronRight
              style={{
                rotate: isCollapsed !== index ? "0deg" : "90deg",
                transition: "all 0.3s ease-in-out",
              }}
            />
          </IconButton>
        </div>
        {isCollapsed === index ? (
          <div
            style={{
              marginLeft: "40px",
              paddingTop: "8px",
              fontSize: screenWidth > 1200 ? "13px" : "12px",
              fontWeight: "400",
              paddingBottom: "10px",
            }}
          >
            {answer}
          </div>
        ) : null}
      </div>
    );
  };
  return (
    <div style={{ overflowX: "hidden" }}>
      {/* header */}
      <div
        style={{
          padding: screenWidth < 1200 ? "15px 20px" : "15px 40px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <img
            src={sllogo}
            style={{ height: screenWidth < 1200 ? "40px" : "40px" }}
          />
        </div>
      </div>

      {/* text title display */}
      <div
        style={{
          padding: screenWidth < 1200 ? "15px" : "15px 40px",
          textAlign: "center",
          width: screenWidth < 1200 ? "100%" : "100%",
          position: "relative",
          zIndex: 1,
        }}
      >
        <div
          style={{
            color: "grey",
            fontSize: screenWidth < 1200 ? 14 : 18,
            fontWeight: 400,
            marginTop: screenWidth < 1200 ? "30px" : "0px",
          }}
        >
          In partnership with
        </div>
        <div
          style={{
            color: "black",
            fontSize: 24,
            fontWeight: 600,
            marginBottom: "20px",
          }}
        >
          <img
            src={chocouplogo}
            style={{ height: screenWidth < 1200 ? "40px" : "60px" }}
          />
        </div>
        <div
          style={{
            color: "black",
            fontSize: screenWidth < 1200 ? 38 : 50,
            fontWeight: 800,
            lineHeight: screenWidth < 1200 ? "40px" : "55px",
          }}
        >
          <span style={{ color: "rgb(45, 128, 195)" }}>Fast Track</span> Your
          Business Funding <br />
          Get Approved in {screenWidth < 1200 ? <br /> : null}24 Hours.
        </div>
        <div
          style={{
            color: "grey",
            fontWeight: 400,
            fontSize: screenWidth < 1200 ? 12 : 18,
            marginTop: "10px",
            width: screenWidth < 1200 ? "70%" : "100%",
            marginLeft: screenWidth < 1200 ? "15%" : "0",
          }}
        >
          Accelerate your business growth with ready access to working capital.
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "25px",
          }}
        >
          <div
            className="button"
            style={{
              background: "rgb(237, 182, 0)",
              color: "white",
              fontWeight: 600,
              fontSize: 20,
              padding: "10px 30px",
              borderRadius: "30px",
            }}
          >
            Get Started
          </div>
        </div>
      </div>

      {/* phone */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: screenWidth < 1200 ? "-50px" : "-85px",
          position: "relative",
          zIndex: 0,
          marginLeft: screenWidth < 1200 ? "10%" : "5%",
        }}
      >
        <img
          src={phone}
          style={{ height: screenWidth < 1200 ? "60vh" : "70vh" }}
        />
      </div>

      {/* Main points */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "40px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "-120px",
            position: "relative",
            zIndex: 1,
            width: screenWidth < 1200 ? "95%" : "85%",
            gap: screenWidth < 1200 ? "10px" : "20px",
            flexWrap: screenWidth < 1200 ? "wrap" : "",
          }}
        >
          <div
            style={{
              padding: "30px",
              borderRadius: "20px",
              background: "rgba(236, 243, 249, 1)",
              textAlign: "center",
              width: screenWidth < 1200 ? "100%" : "50%",
              height: screenWidth < 1200 ? "auto" : "300px",
              position: "relative",
              overflow: "hidden",
              boxShadow: "inset -5px -5px 15px rgba(0,0,0,0.3)",
              minHeight: screenWidth < 1200 ? "350px" : "0px",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: screenWidth < 1200 ? "50%" : "60%",
                right: 0,
                transform: "translate(0, -50%)",
                zIndex: 0,
              }}
            >
              <img
                src={maskotImg}
                style={{ height: screenWidth < 1200 ? "280px" : "350px" }}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%",
                width: screenWidth < 1200 ? "65%" : "75%",
                position: "relative",
                zIndex: 2,
              }}
            >
              <div
                style={{
                  fontWeight: 800,
                  fontSize: screenWidth < 1200 ? 25 : 30,
                  lineHeight: screenWidth < 1200 ? "30px" : "35px",
                  textAlign: "left",
                  color: "rgba(8, 25, 39, 0.8)",
                }}
              >
                Fast Loan Application
                <br /> Within 24 hours.
              </div>
              <div
                style={{
                  fontWeight: 400,
                  fontSize: 15,
                  lineHeight: "19px",
                  textAlign: "left",
                  color: "rgba(8, 25, 39, 0.8)",
                }}
              >
                From Documents to disbursement - Done in days, not weeks. Get
                your business funded before your kopi gets cold. Our partnership
                with {partner} allows us to provide you a fast track to funding
                putting your applications at the top of the line.
              </div>
            </div>
          </div>
          <div
            style={{
              padding: "30px",
              borderRadius: "20px",
              background: "rgba(8, 25, 39, 0.8)",
              textAlign: "center",
              width: screenWidth < 1200 ? "calc(50% - 10px)" : "25%",
              boxShadow: "inset -5px -5px 15px rgba(0,0,0,0.3)",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%",
                width: screenWidth < 1200 ? "100%" : "75%",
              }}
            >
              <div
                style={{
                  fontWeight: 800,
                  fontSize: screenWidth < 1200 ? 25 : 30,
                  lineHeight: screenWidth < 1200 ? "30px" : "35px",
                  textAlign: "left",
                  color: "white",
                }}
              >
                Quantum up to
                <br />{" "}
                <span style={{ color: "rgb(237, 182, 0)" }}>S$ 100,000</span>
              </div>
              <div
                style={{
                  fontWeight: 400,
                  fontSize: 15,
                  lineHeight: "19px",
                  textAlign: "left",
                  color: "white",
                }}
              >
                Apply loans of up to 100k. No delay, no fuss, all within 24
                hours.
              </div>
            </div>
          </div>
          <div
            style={{
              padding: "30px",
              borderRadius: "20px",
              background: "rgba(8, 25, 39, 0.8)",
              textAlign: "center",
              width: screenWidth < 1200 ? "calc(50% - 10px)" : "25%",
              boxShadow: "inset -5px -5px 15px rgba(0,0,0,0.3)",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%",
                width: screenWidth < 1200 ? "100%" : "75%",
              }}
            >
              <div
                style={{
                  fontWeight: 800,
                  fontSize: screenWidth < 1200 ? 25 : 30,
                  lineHeight: screenWidth < 1200 ? "30px" : "35px",
                  textAlign: "left",
                  color: "white",
                }}
              >
                Free
                <br />{" "}
                <span style={{ color: "rgb(237, 182, 0)" }}>
                  Concierge Service
                </span>
              </div>
              <div
                style={{
                  fontWeight: 400,
                  fontSize: 15,
                  lineHeight: "19px",
                  textAlign: "left",
                  color: "white",
                }}
              >
                Smartlend handles your Choco Up loan Journey, providing you with
                fully guided submission at zero fees.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "140px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "-120px",
            position: "relative",
            zIndex: 1,
            width: screenWidth < 1200 ? "95%" : "85%",
            gap: "20px",
          }}
        >
          <div
            style={{
              padding: "30px",
              borderRadius: "20px",
              background: "rgba(236, 243, 249, 1)",
              textAlign: "center",
              width: "100%",
              position: "relative",
              boxShadow: "inset -5px -5px 15px rgba(0,0,0,0.3)",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <div
                style={{
                  height: screenWidth < 1200 ? "50px" : "70px",
                  width: "50%",
                  display: "flex",
                  justifyContent: "flex-end",
                  overflowX: "hidden",
                  borderRight: "1px solid grey",
                }}
              >
                <img
                  src={sllogo}
                  style={{ height: screenWidth < 1200 ? "50px" : "70px" }}
                  className="moving-image"
                />
              </div>
              <div
                style={{
                  height: "70px",
                  width: "52%",
                  display: "flex",
                  justifyContent: "flex-start",
                  overflowX: "hidden",
                }}
              >
                <img
                  src={chocouplogo}
                  style={{ height: screenWidth < 1200 ? "50px" : "70px" }}
                  className="moving-image-op"
                />
              </div>
            </div>
            <div
              style={{
                fontWeight: 400,
                fontSize: 15,
                lineHeight: "19px",
                textAlign: "center",
                color: "rgba(8, 25, 39, 0.8)",
                marginTop: "20px",
              }}
            >
              With SmartLend being Singapore's most trusted SME loan aggregator
              - helping businesses secure the best financing options in days,
              not weeks and Choco Up a leading fintech platform providing
              flexible non dilutive-funding for SMEs with lightning-fast
              turnaround.
            </div>
          </div>
        </div>
      </div>

      {/* singpass authentication */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: screenWidth < 1200 ? "80px 8%" : "80px 20%",
          gap: "60px",
          flexWrap: screenWidth < 1200 ? "wrap" : "",
        }}
      >
        <div
          style={{
            width: screenWidth < 1200 ? "100%" : "calc(50% - 60px)",
            display: "flex",
            justifyContent: screenWidth < 1200 ? "center" : "flex-end",
          }}
        >
          <img
            src={singpassScreen}
            style={{
              width: screenWidth < 1200 ? "40vw" : "20vw",
              borderRadius: "20px",
              boxShadow: "5px 5px 15px rgba(8, 25, 39, 0.3)",
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: screenWidth < 1200 ? "center" : "flex-start",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              fontSize: screenWidth < 1200 ? 30 : 35,
              lineHeight: screenWidth < 1200 ? "35px" : "40px",
              fontWeight: 800,
              textAlign: screenWidth < 1200 ? "center" : "left",
            }}
          >
            <span
              style={{
                color: "rgb(37, 97, 153)",
                fontWeight: 800,
                fontSize: screenWidth < 1200 ? 35 : 45,
                textAlign: screenWidth < 1200 ? "center" : "left",
              }}
            >
              Faster and Secure
            </span>
            <br /> Authentication with Singpass
            <div
              style={{
                fontSize: screenWidth < 1200 ? 14 : 18,
                fontWeight: 300,
                color: "grey",
                lineHeight: screenWidth < 1200 ? "18px" : "23px",
                marginTop: "10px",
                textAlign: screenWidth < 1200 ? "center" : "left",
              }}
            >
              Providing you a more secure and easy method to let our lenders
              know who you are whilst maintaining your security.
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "25px",
            }}
          >
            <div
              className="button"
              style={{
                background: "rgb(237, 182, 0)",
                color: "white",
                fontWeight: 600,
                fontSize: 20,
                padding: "10px 30px",
                borderRadius: "30px",
              }}
            >
              Try Now
            </div>
          </div>
        </div>
      </div>

      {/* as featured on */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          position: "relative",
          zIndex: 1,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: "85%",
            padding: "30px",
            borderRadius: "20px",
            background: "rgba(236, 243, 249, 1)",
            textAlign: "center",
            boxShadow: "inset -5px -5px 15px rgba(0,0,0,0.3)",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              color: "rgba(8, 25, 39, 0.8)",
              fontWeight: 800,
              fontSize: screenWidth < 1200 ? 35 : 40,
            }}
          >
            As Featured on
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-evenly",
              padding: "0px 20px",
            }}
          >
            <img
              src={bank_image}
              alt={bank_image}
              onClick={() => {
                window.location.href =
                  "https://www.straitstimes.com/paid-press-releases/disrupting-sme-lending-smartlend-launches-free-digital-loan-platform-20250612";
              }}
              style={{
                borderRadius: "30px",
                height: "110px",
                width: "110px",
                objectFit: "cover",
                cursor: "pointer",
              }}
            />
            <img
              src={bank_image1}
              alt={bank_image1}
              onClick={() => {
                window.location.href =
                  "https://www.moneyfm893.sg/pr-newswire/disrupting-sme-lending-smartlend-launches-free-digital-loan-platform-23753/";
              }}
              style={{
                borderRadius: "30px",
                height: "110px",
                width: "110px",
                marginLeft: "20px",
                objectFit: "cover",
                cursor: "pointer",
              }}
            />
            <img
              src={bank_image2}
              alt={bank_image2}
              onClick={() => {
                window.location.href =
                  "https://www.theasianbanker.com/mediafeed-news/details?rkey=20250612AE09075&filter=23792";
              }}
              style={{
                borderRadius: "30px",
                height: "110px",
                width: "110px",
                marginLeft: "20px",
                objectFit: "cover",
                cursor: "pointer",
              }}
            />
            <img
              src={bank_image3}
              alt={bank_image3}
              onClick={() => {
                window.location.href =
                  "https://themalaysianreserve.com/2025/06/12/disrupting-sme-lending-smartlend-launches-free-digital-loan-platform/";
              }}
              style={{
                borderRadius: "30px",
                height: "110px",
                width: "110px",
                marginLeft: "20px",
                objectFit: "cover",
                cursor: "pointer",
              }}
            />
            <img
              src={bank_image4}
              alt={bank_image4}
              onClick={() => {
                window.location.href =
                  "https://techcollectivesea.com/2025/05/20/sme-financing-southeast-asia/";
              }}
              style={{
                borderRadius: "30px",
                height: "110px",
                width: "110px",
                objectFit: "cover",
                cursor: "pointer",
              }}
            />
            <img
              src={bank_image5}
              alt={bank_image5}
              onClick={() => {
                window.location.href =
                  "https://thefinance.sg/pr-newswire/?rkey=20250612AE09075&filter=19895";
              }}
              style={{
                borderRadius: "30px",
                height: "110px",
                width: "110px",
                objectFit: "cover",
                marginRight: "60px",
                cursor: "pointer",
              }}
            />
            <img
              src={bank_image7}
              alt={bank_image7}
              onClick={() => {
                window.location.href =
                  "https://finance.yahoo.com/news/disrupting-sme-lending-smartlend-launches-080300477.html";
              }}
              style={{
                borderRadius: "30px",
                height: "110px",
                width: "110px",
                objectFit: "cover",
                marginRight: "60px",
                cursor: "pointer",
              }}
            />
          </div>
        </div>
      </div>

      {/* FAQ section */}

      <div
        className="faq"
        style={{
          display: "flex",
          flexDirection: screenWidth > 1200 ? "row" : "column",
          padding:
            screenWidth > 1200 ? "80px 15% 120px 15%" : "60px 10% 180px 10%",
          position: "relative",
          zIndex: 201,
          background: "white",
          alignItems: "flex-start",
          justifyContent: "space-between",
          overflow: "hidden",
        }}
      >
        <div style={{ width: screenWidth > 1200 ? "45%" : "100%" }}>
          <div
            style={{
              color: "rgb(37, 97, 153)",
              fontWeight: 800,
              fontSize: screenWidth > 1200 ? "55px" : "40px",
              lineHeight: screenWidth > 1200 ? "60px" : "45px",
              marginTop: screenWidth > 1200 ? "15px" : "5px",
            }}
          >
            You asked, we answered.
          </div>
          <div
            style={{
              color: "rgb(120,120,120)",
              fontSize: "14px",
              lineHeight: "20px",
              fontWeight: 400,
              marginTop: "15px",
            }}
          >
            Can't find your question? View all our{" "}
            <span
              onClick={() => {
                history.push("/frequentlyaskedquestions");
                window.scrollTo(0, 0);
              }}
              style={{
                textDecoration: "underline",
                color: "rgb(237, 182, 0)",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              FAQ’s
            </span>
            , chat with us on
            <span
              onClick={() => {
                window.location.href = "https://wa.me/6587853373";
              }}
              style={{
                textDecoration: "underline",
                color: "rgb(237, 182, 0)",
                fontWeight: 600,
                cursor: "pointer",
                marginLeft: "5px",
              }}
            >
              WhatsApp
            </span>
            , or email us via:
            <span
              onClick={() => {
                window.location.href = "mailto:hello@smart-lend.com";
              }}
              style={{
                textDecoration: "underline",
                color: "rgb(237, 182, 0)",
                fontWeight: 600,
                cursor: "pointer",
                marginLeft: "5px",
              }}
            >
              hello@smart-lend.com
            </span>
          </div>
        </div>
        <div
          style={{
            width: screenWidth > 1200 ? "45%" : "100%",
            marginTop: screenWidth > 1200 ? "0px" : "15px",
          }}
        >
          {" "}
          {faqs.map((faq, index) => (
            <FAQItem
              key={faq.id}
              id={faq.id}
              title={faq.title}
              answer={faq.answer}
              index={index}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TestingLandingPageTemplate;
